<div class="min-h-screen flex flex-col bg-transparent">
  <app-header [hideToggle]="true"></app-header>
  <main class="grow p-4 md:p-6 overflow-auto">
    <router-outlet></router-outlet>
  </main>
  <app-footer class="shrink-0"></app-footer>
</div>
